import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';

export const adminGuard: CanActivateFn = () => {
  const identity = inject(NsideIdentityService);
  const router = inject(Router);

  return identity.isNsideAdmin().pipe(
    map(isAdmin => (isAdmin ? true : router.createUrlTree(['/no-access'])))
  );
};
